import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import './styles.scss'
import { getStaticImage } from 'utils/statics'
import ClickOutHandler from 'react-onclickout'
import { getOperatorNameOrEmail } from 'utils/Operator'
import { ButtonTag } from 'components/Form'
import { lang } from 'utils/helpers'
import { useWindowSize } from 'hooks'
import { apiInchat } from 'api'
import SaveToastNotification from 'utils/toasts/SaveToastNotification'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { toastMessage } from 'utils/messages'
import { useDispatch } from 'react-redux'
import inchatActions from 'redux/inchat/actions'

const MentionsPopup = ({ operatorInfo, togglePopup, toggleBtnRef, isOpenPopup }) => {
  const { picture, name, lastname, email, _id } = operatorInfo

  const [toggleBtnCoords, setToggleBtnCoords] = useState(null)

  const history = useHistory()
  const dispatch = useDispatch()

  const size = useWindowSize()
  const modalPortal = document.getElementById('modal-portal')

  useEffect(() => {
    if (toggleBtnRef?.current) {
      setToggleBtnCoords(toggleBtnRef.current.getBoundingClientRect())
    }
  }, [toggleBtnRef, size])

  useEffect(() => {
    toggleList(true)
  }, [])


  const toggleList = (value=false) => {
    if(value) {
      modalPortal.style.display = 'flex'
    } else {
      modalPortal.style.display = 'none'
    }
  }

  const toggle = () => {
    toggleList()
    togglePopup()
  }

  const handleOpenConversation = async () => {
    const data = await handleCreateConversation()
    if(data){
      toggleList()
      history.push(`${history.location.pathname}?user_id=${data.conversationId}`)
    }
  }

  const handleCreateVideocall = async () => {
    const dataConversation = await handleCreateConversation()
    if(dataConversation){
      history.push(`${history.location.pathname}?user_id=${dataConversation.conversationId}`)
      apiInchat.createJoinLink({ conversationId: dataConversation.conversationId })
        .then(({ data: { data } }) => {
          dispatch(inchatActions.editMessage({
            message: data.url,
            isThread: false,
            messageId: undefined,
            external: true,
            parentId: undefined,
            conversationId: dataConversation.conversationId,
          }))
          navigator.clipboard.writeText(data.url)
          toastMessage(lang('dashboard_videocall-url-copied-clipboard'))
        })
        .catch(console.error)
    }
    toggleList()
  }

  const handleCreateConversation = async () => {
    try {
      const { data } = await apiInchat.createConversation({
        type: 'direct',
        userIds: [_id]
      })
      return data.data || ''
    } catch (error) {
      SaveToastNotification.error({ text: lang('dashboard_conversation-not-opened') })
    }
  }

  const topPosition = toggleBtnCoords && toggleBtnCoords.y
    ? (toggleBtnCoords.y - 200 < 0) ? 20 : toggleBtnCoords.y - 210
    : 0
  return (
    ReactDOM.createPortal(
      <ClickOutHandler onClickOut={toggle}>

        <div
          className='mentions-menu-container'
          style={{
            top: topPosition,
            left: toggleBtnCoords && toggleBtnCoords.x ? toggleBtnCoords.x - 50 : 0,
          }}

        >
          <figure className='mentions-menu-container__banner'>
            <img
              src={picture || getStaticImage('/icons/orange-brand/icon-avatar.svg')}
              alt={`${name} ${lastname}`}
              onError = {event => {
                event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
                event.onerror = null
              }}
            />
          </figure>
          <span className='mentions-menu-container__name text-ellipsis'>{getOperatorNameOrEmail({ name, surname:lastname, email })}</span>
          <div className='mentions-menu-container__buttons'>

            <ButtonTag
              value={lang('dashboard_send-message')}
              icon={<i className="fa fa-comment-o icon-size icon-size__orientation"></i>}
              className={'mentions-menu-container__buttons--button'}
              onClick={handleOpenConversation}
            />
            <ButtonTag
              value={lang('dashboard_videocall')}
              icon={<i className="fa fa-video-camera icon-size"></i>}
              className={'mentions-menu-container__buttons--button'}
              onClick={handleCreateVideocall}
            />
          </div>
        </div>
      </ClickOutHandler>,
      modalPortal
    )
  )
}

export default MentionsPopup